
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapGetters } from 'vuex'
export default {
  name: 'TeflEuropeGuide',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    images: {
      type: Boolean,
    },
    guide: {
      type: String,
    },
    title: {
      type: String,
    },
    cover: {
      type: String,
    },
    inside: {
      type: String,
    },
    squeeze: {
      type: String,
      default: ''
    },
    campaign: {
      type: String,
      default: 'Newsletter'
    },
  },
  data() {
    return {
      a: Math.ceil(Math.random() * 10),
      b: Math.ceil(Math.random() * 10),
      showError: false,
      answer: null,
      form: {},
      messageSent: false,
      merge_vars: {},
      loading: false,
      resultMessage: '',
    }
  },
  computed: {
    ...mapGetters({
      userId: 'user/id',
    }),
    bottest() {
      return `What is ${this.a} + ${this.b}?`
    },
    c() {
      return parseInt(this.a + this.b)
    },
  },
  methods: {
    async Submit() {
      console.log('Submit the form')
      this.loading = true
      console.log(this.form)
      const teflID = new URLSearchParams(window.location.search).get(
        "teflid"
      );
      const dataToSend = { 
        email: this.form.email, 
        campaign: this.$props.campaign, 
        merge_vars: this.merge_vars 
      }
      if(teflID) { // check if teflid parameter is set to anything
        dataToSend.referrer = teflID
      } else {
          const teflID2 = localStorage.getItem('tefl_teflid');
          if(teflID2) { // check if teflid parameter is set to anything
            dataToSend.referrer = teflID2
          }
      }

      // GCLID
      const gclidData = JSON.parse(localStorage.getItem('gclid'));
      // const gclid = gclidData.value
      if(gclidData) { // check if teflid parameter is set to anything
        dataToSend.gclid = gclidData.value
      }
      
      // FBCLID
      const fbclidData = JSON.parse(localStorage.getItem('fbclid'));
      // const gclid = gclidData.value
      if(fbclidData) { // check if teflid parameter is set to anything
        dataToSend.fbclid = fbclidData.value
      }

      /*

      const result = await this.$axios
        .$post(
          // TODO: implemnet this on server
          location.protocol +
            '//' +
            location.host +
            '/.netlify/functions/newsletter',
          dataToSend
        )
        .catch((error) => {
          console.log('Error', error)
        })
      this.loading = false
      console.log('got', result)

      */


      const result = await this.$axios
      .$post(
        `${process.env.DATA_URL}/klaviyo/automations/form_request/send`,
            dataToSend
        )
        /*
        .$post(
          `${process.env.DATA_URL}/mailchimp/automations/form_request/send`,
            dataToSend
        )
        */
        .catch((error) => {
          console.log('Error', error)
        })

        this.loading = false
        console.log('got', result)


      if (result) {
        this.resultMessage = 'Thanks for signing up to our newsletter'
        // WINDOW CHECK FOR TRACKING - NOT SURE IF NEEDED OR NOT
        if ( window ) {
          // Identify via plugin
          this.$rs.identify(this.form.email, {
            userId: this.userId,
            name: this.merge_vars.FNAME + ' ' + this.merge_vars.LNAME,
            email: this.form.email,
          }, {
            integrations: {
              "Klaviyo": false,
            },
          })
          // Track via rudderstack
          this.$rs.track("Generate Lead", {
            form_name: this.$props.campaign.toLowerCase()+' form',
          }, {
            integrations: {
              "Klaviyo": false,
            },
          })
          // Track via GTM
          this.$gtm.push({
            event: 'generate_lead',
            form_name: this.$props.campaign.toLowerCase()+' form',
            enhanced_conversion_data: {
              "email": this.form.email
            },
            user_data: {
              "email": this.form.email
            }
          });
        }
      } else {
        this.resultMessage = 'There is an error on your form'
      }
    },
  },
}
